export default "__VITE_ASSET__oyKCALxAIw6qJYMqiP_KZg__"